export enum SignalType {
  LockDown,
  Unlock,
  startSession,
  endSession,
  Connected,
  Disconnected,
  SignalReceived,
  Error,
  RemoveEvent,
  UpdateEvent,
  Unknown,
  Ping,
  Pong,
  Transaction,
  Reconnected,
  RollBack,
}

export enum AssistanceType {
  help,
}

export enum CompanyType {
  Residential = 0,
  Commercial = 1,
}

export enum ClientType {
  NotProvided,
  AdminPortal,
  SimulatorTerminal,
}

export enum SelectFilterType {
  Customer,
  Location,
  Simulator,
  Date,
}

export enum ColorPalette {
  Primary = '#3369FF',
  Secondary = '#FFC700',
  Info = '#FFFFFF',
  Success = '#009840',
  Warning = '#FFC700',
  Danger = '#E20000',
}
